import {Link} from 'react-router-dom';
import { useAppDispatch } from 'hooks';

// material-ui
import {ButtonBase} from '@mui/material';

// project imports
import config from 'config';
import Logo from 'ui-components/Logo';
import { openMenu } from 'store/menuReducer';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const dispatch = useAppDispatch();
    return (
        <ButtonBase disableRipple onClick={() => dispatch(openMenu('default'))} component={Link}
                    to={config.defaultPath}>
            <Logo/>
        </ButtonBase>
    );
};

export default LogoSection;
